// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"f89b1c9b","233":"0e53afe2","453":"8521f3f5","607":"872da3d7","784":"41eb9b87","833":"9e197eae","954":"da211b0d"}[chunkId] + ".chunk.js";
};